import { CoreCancelledGameCommunicationProcessor } from '@pp/core/src/controllers/gameCommunication/processors/CoreCancelledGameCommunicationProcessor';
import {
  GameCommunicationMessageType,
  IGameCommunicationProcessor,
} from '@pp/core/src/controllers/gameCommunication/types';

import { airPlaneActions } from '../../../store/slices/highflyerAirPlane/slice';
import { airplaneStates } from '../../../store/slices/highflyerAirPlane/types';
import { highflyerStateActions } from '../../../store/slices/highflyerState/slice';

export class GameComunicationGameCanceledProcessor
  extends CoreCancelledGameCommunicationProcessor
  implements IGameCommunicationProcessor
{
  delay = 0;

  process(message: GameCommunicationMessageType): void {
    super.process(message);
    this.store.dispatch(airPlaneActions.setCurrentState(airplaneStates.FLEW_AWAY));
    this.store.dispatch(highflyerStateActions.setIsSingleBetPlaced(false));
    setTimeout(() => {
      this.store.dispatch(highflyerStateActions.setMultiplier(null));
    }, 2000);
  }
}
